<template>
  <div>
    <div class="title h5 pt-3 pb-3">{{ formTitle }}</div>
    <div class="form">
      <SInput
        inputId="current-username"
        name="current-username"
        label="Username or email"
        ref="username"
        data-cy="loginPageUsername"
        fieldClass="form-input"
        @submit="loginSubmit"
        :autofocus="true"
        :required="true"
        v-model="credentials.username"
        :class="[
          {
            'has-value': credentials.username && !hasError,
            'has-error': hasError,
          },
        ]"
        @input="clearError()"
      />
      <SInput
        inputId="current-password"
        name="current-password"
        label="Password"
        type="password"
        ref="password"
        fieldClass="form-input"
        data-cy="loginPagePassword"
        @submit="loginSubmit"
        :required="true"
        v-model="credentials.password"
        :class="[
          {
            'has-value': credentials.password && !hasError,
            'has-error': hasError,
          },
        ]"
        @input="clearError()"
      />
    </div>
    <span class="login-error" v-if="errorResponse">{{ errorResponse }}</span>
    <div class="actions md-layout md-alignment-center-space-between">
      <SButtonMaterial
        class="submit-login-btn"
        buttonType="button"
        color="primary"
        textColor="white"
        materialClass="dense"
        text="log in"
        data-cy="loginPageButton"
        @button="loginSubmit"
      />
      <SButtonMaterial
        class="forgot-login-btn"
        buttonType="button"
        textColor="tertiary"
        materialClass="dense"
        type="primary"
        text="Forgot my username/Password"
        @button="$emit('forgot')"
      />
    </div>
    <!-- <div class="or"></div> -->
    <!-- Disable facebook login until fixed -->
    <!-- <SButton
      text="<i class='fab fa-facebook-f' aria-hidden='true'></i>Log in with Facebook"
      size="lg"
      class="bg-facebook full-width btn-icon-left login-btn mb-2"
      :landingPageButton="true"
      @button.prevent="fbLogin"
    /> -->
    <LoadingSpinner position="absolute" v-if="tryingToLogin" />
  </div>
</template>

<script>
import SInput from "@/material-components/atoms/SInput.vue";
// import SButton from "@/components/atoms/SButton.vue";
import SButtonMaterial from "@/material-components/atoms/SButtonMaterial.vue";
import Auth from "@/modules/Auth";
import { mapActions } from "vuex";
import Global from "@/constants/Global.js";
import * as moment from "moment";
import LoadingSpinner from "@/material-components/atoms/LoadingSpinner.vue";

export default {
  name: "SLoginForm",
  components: {
    SInput,
    // SButton,
    SButtonMaterial,
    LoadingSpinner,
  },
  props: ["redirectTo", "title"],
  data() {
    return {
      errorResponse: null,
      triedToLogin: false,
      tryingToLogin: false,
      credentials: {
        username: "",
        password: "",
      },
      hasError: false,
    };
  },
  computed: {
    currentYear: function () {
      return moment().format("YYYY");
    },
    formTitle() {
      if (this.title) {
        return this.title;
      } else return "Log in";
    },
    isEmptyForm() {
      return this.credentials.username === "" || this.credentials.password === ""
    },
  },
  methods: {
    ...mapActions(["startSession", "getAllGroups"]),
    fbLogin() {
      window.location.replace(`${Global.getServerDomain()}/auth/facebook`);
    },
    loginSubmit() {
      this.tryingToLogin = true;
      this.triedToLogin = true;
      this.errorResponse = null;
      if (this.isEmptyForm) {
        this.$refs.password.setErrorMessage(
          "Please, complete the form to log in"
        );
        this.hasError = true;
        this.tryingToLogin = false;
        return;
      } else if (this.$refs.password.errorMessage) {
        this.$refs.password.clearError();
        this.hasError = false;
      }

      this.fetchLoginAPI()
        .then((result) => {
          this.checkFetchTokenValid(result);
        })
        .catch((error) => {
          console.log(error);
          this.tryingToLogin = false;
        });
    },
    fetchLoginAPI() {
      return new Promise(async (resolve, reject) => {
        fetch(Global.getServerDomain() + "/login", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            username: this.credentials.username,
            password: this.credentials.password,
          }),
        })
          .then(function (res) {
            resolve(res.json());
          })
          .catch((error) => {
            reject(error);
            console.error("Error: ", error);
          });
      });
    },
    checkFetchTokenValid(status) {
      const result = status;
      if (!result.error) {
        this.saveUserInfoToLocalStorage(result);
        this.saveUserInfoToState();

        if (this.redirectTo) {
          this.$router.push({
            path: this.redirectTo,
          });
        } else {
          this.$router
            .push({
              name: "Feed",
              params: { id: result.sUserId },
              query: { feature: status.loginType },
            })
            .catch(() => {
              this.$router.push({
                name: "Feed",
                params: { id: result.sUserId },
                query: { feature: status.loginType },
              });
            });
        }
      } else {
        if (
          result.error === "Incorrect username or password" ||
          result.error === "Please enter a valid username and password."
        ) {
          this.errorResponse =
            "You have entered an invalid username or password";
        } else if (result.error === "User has not been confirmed.") {
          const objResend = {
            email: result.email,
            token: result.token,
          };
          this.$emit("emailTaken", objResend);
          $("#emailTaken").modal("show");
        } else {
          this.errorResponse =
            "Something went wrong. Please wait a moment and try again.";
        }
        this.hasError = true;
        $("#login").modal("show");
        this.tryingToLogin = false;
      }
    },
    saveUserInfoToLocalStorage(status) {
      Auth.authenticateUser(status.token, status.createdAt, status.sUserId);
      localStorage.setItem("user_id", status.sUserId);
      console.log("passei4");
    },
    saveUserInfoToState() {
      this.startSession();
      this.getAllGroups();
    },
    clearError() {
      if (this.hasError === true) this.hasError = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  margin-bottom: 12px;
  margin-right: auto;
}
.login-error {
  color: $danger;
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-bottom: 0.5rem;
}
.submit-login-btn {
  width: 60%;
  height: 41px;
  font-size: 14px;
}
.actions {
  justify-content: center;
}
.forgot-login-btn {
  width: 85%;
  height: 20%;
  white-space: normal;
  padding: 0.3rem;
  margin-right: 0;
}
.md-field {
  margin: 4px 0 20px;
}
.md-list-item-text p {
  white-space: normal;
  padding-bottom: 0;
}
</style>

<style lang="scss">
.has-value .md-field.md-theme-swampum-primary label {
  color: $primary !important;
}
.has-value .form-input {
  border: 1px solid $primary;
}
.has-error .md-field.md-theme-swampum-primary label {
  color: $danger !important;
}
.has-error .form-input {
  border: 1px solid $danger;
}
@media screen and (max-width: 425px) {
  .btn-icon-left svg {
    margin-left: 20px;
    margin-right: 5px;
  }
}
</style>
